<ion-button
  fill="outline"
  class="file-upload-btn"
  (click)="uploadClick.emit()"
  [disabled]="disabled"
>
  <ion-icon [src]="SRC.UPLOAD"></ion-icon>
  <span class="upload-text">
    {{ CONSTS.FILE_UPLOAD }}
  </span>
</ion-button>
